import Form from "react-bootstrap/Form";

export default function DateRangeFilter({ column, onFilterChange }) {
  const onChangeDate = (e, type) => {
    //set undefined if both from and to are empty, otherwise set the filter value to the from and to values
    if (
      !e.target.value &&
      !column.getFilterValue()?.[type === "from" ? "to" : "from"]
    ) {
      onFilterChange(undefined); // backend sees no filter
      return;
    }
    onFilterChange((old) => ({
      from: type === "from" ? e.target.value : old?.from || "",
      to: type === "to" ? e.target.value : old?.to || "",
      type: "dateRangeFilter", // Add type to identify this filter as a date range filter
    }));
  };

  return (
    <div>
      <Form.Group className="mb-2">
        <Form.Label className="fs-6 text fw-light">Od</Form.Label>
        <Form.Control
          type="date"
          value={column.getFilterValue()?.from || ""}
          onChange={(e) => {
            onChangeDate(e, "from");
          }}
        />
      </Form.Group>

      <Form.Group>
        <Form.Label className="fs-6 text fw-light">Do</Form.Label>
        <Form.Control
          type="date"
          value={column.getFilterValue()?.to || ""}
          onChange={(e) => {
            onChangeDate(e, "to");
          }}
        />
      </Form.Group>
    </div>
  );
}
